export enum MultiFacetSelectorLayout {
  horizontal = 'horizontal',
  vertical = 'vertical',
}
